import React from 'react';
import {StyleSheet, View, Text} from 'react-native';
import {colors} from 'src/assets';

export type HistoryRowProps = {
  date?: string;
  time: string;
  text: string;
  variant?: 'gray' | 'red';
};

export const HistoryRow: React.FC<HistoryRowProps> = ({
  date,
  time,
  text,
  variant,
}) => {
  return (
    <View style={[styles.container]}>
      <View style={styles.content}>
        <View style={styles.leftContainer}>
          <Text style={[styles.text, variant === 'red' ? styles.textRed : {}]}>
            {date}
          </Text>
          <Text style={[styles.text, variant === 'red' ? styles.textRed : {}]}>
            {time}
          </Text>
        </View>

        <View style={styles.rightContainer}>
          <Text style={[styles.text, variant === 'red' ? styles.textRed : {}]}>
            {text}
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingVertical: 6,
    backgroundColor: colors.chokuGray11,
    flexDirection: 'column',
    borderBottomColor: colors.white,
    borderBottomWidth: 1,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  leftContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 130,
  },
  text: {
    color: colors.chokyGray10,
    fontSize: 12,
  },
  textRed: {
    color: colors.chokuRed,
  },
  rightContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
});
